import React from 'react'
import { Button, Grid } from '@material-ui/core'
import { CustomModal } from '../../../../components/common/CustomModal'
import { BiotrackUserOptionsModalProps } from './biotrackUserTypes'

export const BiotrackUserOptionsModal = ({
  open,
  onClose,
  onGoBack,
  onCreate,
  modalTitle = 'Biotrack User',
  linkButtonText = 'Link',
  createButtonText = 'Create',
}: BiotrackUserOptionsModalProps & {
  onGoBack: () => void
  onCreate: () => void
}) => {
  return (
    <CustomModal open={open} onClose={onClose} size="small">
      <CustomModal.Header
        title={modalTitle}
        onClose={onClose}
        variant="caption"
        titleSx={{ textAlign: 'center' }}
      />
      <CustomModal.Content>
        <Grid container style={{ paddingTop: '10px' }}>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'center' }}>
            <Button className="primary-button" onClick={onGoBack}>
              {linkButtonText}
            </Button>
          </Grid>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'center' }}>
            <Button className="primary-button" onClick={onCreate}>
              {createButtonText}
            </Button>
          </Grid>
        </Grid>
      </CustomModal.Content>
      <CustomModal.Footer />
    </CustomModal>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Employees/BiotrackUser/BiotrackUserOptionsModal.tsx